/* global axios */
import ApiClient from './ApiClient';

class MarketingCostsAPI extends ApiClient {
  constructor() {
    super('marketing_costs', { accountScoped: true });
  }

  getSuggestions() {
    return axios.get(`${this.url}/suggestions`);
  }

  getSummary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }
}

export default new MarketingCostsAPI();
